import Base from '@domain/composition/Base';
import { instanceofType } from './utils';

export default class DomainElementsFilter {
    static applyFilter<T extends Base = Base>(elements: Array<T>, method: 'models' | 'partialModel' | 'applicationLocation' | 'generic' | 'type', value?) {
        switch (method) {
            case 'models':
                return this.filterByModels(elements, value)
            case 'partialModel':
                return this.filterByPartialModel(elements, value)
            case 'applicationLocation':
                return this.filterByApplicationLocation(elements, value)
            case 'type':
                return this.filterByType(elements, value)
            case 'generic':
                return this.filterGenericModels(elements)
            default:
                throw 'Cannot filter by this method'
        }
    }

    private static filterByPartialModel<T extends Base = Base>(elements: Array<T>, partialModel: string) {
        const filteredElements = elements.filter(elem => elem.getModel()?.includes(partialModel))
        return filteredElements
    }

    private static filterByModels<T extends Base = Base>(elements: Array<T>, models: Array<string>) {
        const filteredElements = elements.filter(elem => models.includes(elem.getModel()))
        return filteredElements
    }

    private static filterByApplicationLocation<T extends Base = Base>(elements: Array<T>, applicationLocation: number | string) {
        const filteredElements = elements
            .filter(elem => elem.getLights()
                .every(light => light.element.getApplicationLocation()
                    .some(el => el.id == applicationLocation)
                )
            )
        return filteredElements
    }

    private static filterByType<T extends Base = Base>(elements: Array<T>, type: string) {
        const elementsByType = elements.filter(obj => instanceofType(obj, type));
        return elementsByType
    }

    private static filterGenericModels<T extends Base = Base>(elements: Array<T>) {
        const filteredElements = elements
            .filter(elem => elem.getLights()
                .every(light => {
                    const model = light.element.getModel()
                    return Number(model) > 100
                })
            )
        return filteredElements
    }
}